import Box from "@/common/components/Box";
import ResumeBox from "@/common/components/ResumeBox";
import { ShowHeader } from "@/common/components/ShowHeader";
import Skeleton from "@/common/components/Skeleton";
import NegotiationHelper from "../../components/NegotiationHelper";
import TextArea from "@/common/components/TextArea";
import Button from "@/common/components/Button";
import { CalendarClockIcon } from "lucide-react";
import EquipmentCategorySummary from "../../components/EquipmentCategorySummary";

const NegotiationsShowLoadingState = () => {
  return (
    <div>
      <div className="flex">
        <ShowHeader
          backTo="/negotiations"
          titleClassName="text-nowrap font-medium text-lg"
          title="Negociações"
          className="w-full"
        />
      </div>

      <Box className="flex gap-6 h-[calc(100vh-128px)] overflow-hidden">
        <div className="w-1/2 flex flex-col gap-4">
          <div className="flex items-center gap-2">
            <Skeleton circle className="size-7" />

            <Skeleton className="w-48 h-6" />
          </div>

          <ResumeBox
            label="Status"
            value={<Skeleton className="w-24" />}
          />

          <NegotiationHelper />

          <TextArea
            label="Proposta da empresa"
            rows={1}
            value=""
            disabled
          />

          <EquipmentCategorySummary />
        </div>

        <div className="w-1/2 flex flex-col gap-4">
          <Box className="flex flex-col gap-4">
            <p>Produtos em negociação</p>

            {new Array(2).fill(0).map((_, i) => (
              <Box className="flex flex-col gap-3" key={`negotiation-loading-product-${i}`}>
                <div className="flex items-center gap-2">
                  <Skeleton className="h-7 w-28" />
                </div>

                <div className="flex flex-col gap-2">
                  <Box className="rounded-xl flex items-end justify-between px-4 py-5">
                    <div className="flex flex-col gap-1">
                      <p className="text-xs font-light">
                        Valor desejado
                      </p>

                      <Skeleton />
                    </div>

                    <div className="flex flex-col items-end">
                      <p className="italic text-xs font-light text-right">
                        Valor no estabelecimento
                      </p>

                      <Skeleton />
                    </div>
                  </Box>

                  <Box className="rounded-xl flex items-end justify-between px-4 py-5">
                    <div className="flex flex-col gap-1">
                      <p className="text-xs font-light">
                        Estimativa de consumo mensal
                      </p>

                      <Skeleton />
                    </div>

                    <div className="flex flex-col items-end">
                      <p className="italic text-xs font-light text-right">
                        Total consumido no mês anterior
                      </p>

                      <Skeleton />
                    </div>
                  </Box>
                </div>

                <Button variant="neutral" className="bg-white-800/30 text-black-500 italic w-full text-sm" disabled>
                  Conferir histórico da negociação

                  <CalendarClockIcon strokeWidth={1.5} size={18} />
                </Button>
              </Box>
            ))}
          </Box>
        </div>
      </Box>
    </div>
  );
};

export default NegotiationsShowLoadingState;
